export enum actionTypes {
  ADD = 'toastsContainer/ADD',
  REMOVE_KEY = 'toastsContainer/REMOVE_BY_KEY',
  REMOVE_ALL = 'toastsContainer/REMOVE_ALL',
}
